module.exports = __webpack_public_path__ + "media/images/ohap_red_alert-23f369c8c9720640d7e8461756db61f4.png";